export class ContentsListDispatcher {
    static $inject = ['props'];
    constructor(props) {
        Object.assign(this, props);
    }
}
export class ContentUpdateAndSave extends ContentsListDispatcher {
    constructor() {
        super();
    }
}
